import { useState, useEffect } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import DefaultCheckbox from '../../Forms/checkbox';
import DefaultInput from '../../Forms/input';

const Label = styled.label`
  font-size: 1rem;
  margin-right: 8px;
`;

const Input = styled(DefaultInput)`
  width: 250px;
  margin-right: 32px;
  padding: 0.5rem;
  margin-left: 8px;
`;

const Checkbox = styled(DefaultCheckbox)`
  width: auto;
  margin-bottom: 0;
  margin-right: 16px;
  font-size: 1rem;
`;

const Wrapper = styled.div`
  position: fixed;
  top: 80px; /* based on header height */
  max-width: 1920px;
  width: 100%;
  z-index: 999;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: ${({theme}) => theme.colors.bg_gray_light};
  padding: 0.5rem;
  box-shadow: 0 0 20px rgb(34 36 38 / 15%);
`;

const Filters = styled.div`
  display: flex;
  flex-direction: row;
`;

function DataFilter ({ onSearchChange, onTypeChange }) {
  const [searchValue, setSearchValue] = useState('');
  const [typeValues, setTypeValues] = useState({
    single: true,
    panorama: true,
    video: true,
    mill: true,
    forest: true,
  })

  const setDebouncedSearch = useDebouncedCallback(() => {
    onSearchChange(searchValue.trim());
  }, 500);

  const setDebouncedType = useDebouncedCallback(() => {
    onTypeChange(typeValues);
  }, 500);

  const handleSearchChange = (val) => {
    setSearchValue(val);
    setDebouncedSearch();
  };

  const handleTypeChange = (id, checked) => {
    setTypeValues(prev => ({
      ...prev, [id]: checked
    }));

    setDebouncedType();
  }

  useEffect(() => {
    onTypeChange(typeValues);
  }, []);

  return (
    <Wrapper>
      <Input
        id="search"
        placeholder="Search..."
        value={searchValue}
        onChange={(ev) => handleSearchChange(ev.target.value)} />

      <Label>Type:</Label>
      <Filters>
        <Checkbox
          id="single"
          label="Photo"
          checked={typeValues.single}
          onChange={(e) => handleTypeChange('single', e.target.checked)} />
        <Checkbox
          id="panorama"
          label="Panorama"
          checked={typeValues.panorama}
          onChange={(e) => handleTypeChange('panorama', e.target.checked)} />
        <Checkbox
          id="video"
          label="Video"
          checked={typeValues.video}
          onChange={(e) => handleTypeChange('video', e.target.checked)} />
        <Checkbox
          id="mill"
          label="Mill"
          checked={typeValues.mill}
          onChange={(e) => handleTypeChange('mill', e.target.checked)} />
        <Checkbox
          id="forest"
          label="Forest"
          checked={typeValues.forest}
          onChange={(e) => handleTypeChange('forest', e.target.checked)} />
      </Filters>
    </Wrapper>
  );
}

DataFilter.propTypes = {
  onSearchChange: func.isRequired,
  onTypeChange: func.isRequired,
}

export default DataFilter;